import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative w-full h-[50vh] sm:h-[60vh] md:h-[70vh] overflow-hidden mt-16 md:mt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1920&q=80"
          alt="Modern living room"
          className="w-full h-full object-cover"
        />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/10 via-transparent to-background/40" />
      </div>

      {/* Hero Title */}
      <div className="relative h-full flex items-center justify-center">
        <motion.h1
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="heading-hero text-foreground/10 select-none pointer-events-none"
          style={{
            fontSize: 'clamp(6rem, 25vw, 20rem)',
            lineHeight: 1,
            fontWeight: 700,
          }}
        >
          StuffLab
        </motion.h1>
      </div>
    </section>
  );
};

export default HeroSection;
